<template>
    <yd-layout>
        <div>
            <tab0 v-show="tab==0"/>
            <tab1 v-show="tab==1"/>
            <tab2 v-show="tab==2"/>
        </div>

        <yd-tabbar slot="tabbar" :active-color="$config('theme')">
            <yd-tabbar-item title="首页" type="a" :active="tab==0" @click.native="onPressTab(0)">
                <yd-icon name="home" slot="icon" size="0.54rem"></yd-icon>
            </yd-tabbar-item>
            <yd-tabbar-item title="工作" type="a" :active="tab==1" @click.native="onPressTab(1)">
                <yd-icon name="ucenter-outline" slot="icon" size="0.54rem"></yd-icon>
            </yd-tabbar-item>
            <yd-tabbar-item title="我的" type="a" :active="tab==2" @click.native="onPressTab(2)">
                <yd-icon name="ucenter-outline" slot="icon" size="0.54rem"></yd-icon>
            </yd-tabbar-item>
        </yd-tabbar>
    </yd-layout>
</template>

<script>
    import Page0 from './common/pages/home.vue'
    import Page1 from './common/pages/home.vue'
    import Page2 from './common/pages/home.vue'

    import {mapState} from 'vuex'

    export default {
        name: 'Home',
        components: {
            'tab0': Page0,
            'tab1': Page1,
            'tab2': Page2,
        },
        props: [],
        data: function () {
            return {
//                tab: 0,
            }
        },
        computed: mapState({
            tab: ({base})=>base.tab,
        }),
        created: function () {

        },
        methods: {
            toInfo: function () {
                this.$push('Info');
            },
            onPressTab: function (tab) {
                this.$store.commit('TAB', tab);
            }
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/modules/Root.vue